import InputField from "components/FormFields/InputField";
import { PayoutModalPropsType } from "components/PayoutManagement/types";
import { addPayoutMethod, updatePayoutMethod } from "constants/apiUrls";
import { PayoutMethodEnum } from "enum/common";
import { useFormik } from "formik";
import { useAppSelector } from "hooks/useRedux";
import { http } from "middleware/apiMiddleware";
import toast from "react-hot-toast";
import { RootState } from "store";
import * as Yup from "yup";

interface IVenmoFormProps {
  data: PayoutModalPropsType;
  afterSubmit: () => void;
  isSubmitting: boolean;
  setIsSubmitting: (value: boolean) => void;
}
const VenmoForm: React.FC<IVenmoFormProps> = ({
  data,
  afterSubmit,
  setIsSubmitting,
}) => {
  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .max(256, "Username can be max of 256 characters")
      .matches(/^@/, "Please enter Venmo user name starting with @")
      .matches(/^[^\s]+$/, "Please enter Venmo user name without spaces")
      .required("This field can not be left blank"),
    phoneNumberLast4: Yup.number()
      .required("This field cannot be left blank")
      .typeError("Must be a number")
      .test(
        "len",
        "Please enter the last 4 digits of the phone number",
        (val: any) => val && val.toString().length === 4
      ),
  });

  const selectedBusiness = useAppSelector(
    (state: RootState) => state.businesses.business
  );

  const isEdit = data?.type === "edit";

  const formik = useFormik({
    initialValues: {
      username: data?.data?.username || "",
      phoneNumberLast4: data?.data?.phoneNumberLast4 || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const payload = {
          username: values.username,
          phoneNumberLast4: values?.phoneNumberLast4,
        };
        if (isEdit) {
          await http.patch(
            updatePayoutMethod(
              PayoutMethodEnum.VENMO,
              data?.data?.uuid || "",
              selectedBusiness?.uuid || ""
            ),
            payload
          );
        } else {
          await http.post(
            addPayoutMethod(
              PayoutMethodEnum.VENMO,
              selectedBusiness?.uuid || ""
            ),
            payload
          );
        }
        afterSubmit();
      } catch (error) {
        toast("Unexpected error occurred while adding/updating payout method");
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  const { values, setFieldValue, errors, handleSubmit, touched } = formik;

  return (
    <div>
      <form onSubmit={handleSubmit} id={PayoutMethodEnum.VENMO}>
        <InputField
          onChange={(e) => {
            setFieldValue("username", e.target.value);
          }}
          value={values?.username}
          label={"Venmo Username"}
          placeholder="Enter venmo user name starting with @"
          id={""}
          error={(touched?.username && errors?.username) || ""}
        />
        <InputField
          type="number"
          onChange={(e) => {
            setFieldValue("phoneNumberLast4", e.target.value);
          }}
          value={values?.phoneNumberLast4}
          label={"Last 4 digit of phone number"}
          placeholder="Enter Last 4 digit of phone number"
          id={""}
          error={(touched?.phoneNumberLast4 && errors?.phoneNumberLast4) || ""}
        />
      </form>
    </div>
  );
};

export default VenmoForm;
